import React, { useRef } from 'react'
import './account-chart.scss'
import { useUpdateEffect } from 'ahooks'
import * as G2 from '@antv/g2'
import { IAccountData } from '../account-checking'

interface AccountChartProps {
    dataList: IAccountData[]
}

const AccountChart: React.FC<AccountChartProps> = props => {
    const chartsRef = useRef<G2.Chart | null>(null)

    useUpdateEffect(() => {
        if (chartsRef.current) chartsRef.current.destroy()
        chartsRef.current = new G2.Chart({
            container: 'chart-container',
            height: 320,
            autoFit: true,
        })

        chartsRef.current.data(
            props.dataList
                .map(v => {
                    return v.payment_data.map(p => ({
                        ...p,
                        date: v.date,
                    }))
                })
                .reduce((prev, next) => [...prev, ...next], [])
                .reverse(),
        )
        chartsRef.current.scale('amount', {
            tickCount: 5,
        })
        chartsRef.current.scale('date', {
            tickCount: 7,
        })
        chartsRef.current.filter('name', val => val === '总收款')
        chartsRef.current.axis('date', {
            label: {
                style: {
                    fill: '#999',
                },
            },
        })

        chartsRef.current.axis('amount', {
            label: {
                formatter: val => `¥${val}`,
                style: {
                    fill: '#999',
                },
            },
        })

        chartsRef.current.tooltip({
            showCrosshairs: true,
            shared: true,
        })

        chartsRef.current.legend({
            marker: {
                symbol: 'circle',
            },
            itemWidth: 90,
            itemHeight: 70,
            itemSpacing: 30,
            itemName: {
                style: {
                    fill: '#999',
                    fontSize: 14,
                },
            },
        })

        chartsRef.current
            .area()
            .position('date*amount')
            .color('name', [
                '#5dc99e',
                '#5ea1f3',
                '#e07cd8',
                '#e88f5e',
                '#826bef',
                '#ed5970',
                '#5B6A91',
                '#FF4343',
                '#999',
                '#F073DD',
                '#50E3FF',
                '#FAB84B',
                '#a6a33b',
                '#a68b3b',
                '#c74949',
            ])
            .animate({
                appear: {
                    animation: 'fade-in', // 动画名称
                    delay: 200,
                    duration: 500,
                },
            })
            .style({
                fillOpacity: 0.1,
            })
        chartsRef.current
            .line()
            .position('date*amount')
            .color('name', [
                '#5dc99e',
                '#5ea1f3',
                '#e07cd8',
                '#e88f5e',
                '#826bef',
                '#ed5970',
                '#5B6A91',
                '#FF4343',
                '#999',
                '#F073DD',
                '#50E3FF',
                '#FAB84B',
                '#a6a33b',
                '#a68b3b',
                '#c74949',
            ])
            .style({
                lineWidth: 2,
            })
            .animate({
                appear: {
                    animation: 'wave-in',
                    delay: 200,
                    duration: 500,
                },
            })

        chartsRef.current.render()

        // chartsRef.current.update({ animation: v === '无' ? false : { appear: { animation: v } } });
    }, [props.dataList])

    return <div id="chart-container" style={{ width: '100%', height: '320px' }} />
}

export default AccountChart
